// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=_v-7b748e94&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/clients/ExchangeRow.vue
// module id = 451
// module chunks = 0